// OSIS - Urmărire Plăți și Încasări - Sistem complet pentru monitorizarea plăților
import React, { useState } from 'react';
import { 
  CreditCard, 
  Clock, 
  CheckCircle, 
  AlertCircle,
  DollarSign,
  Calendar,
  Search,
  Filter,
  Plus,
  Eye,
  Send,
  Download,
  TrendingUp,
  User,
  Building,
  Phone,
  Mail,
  MapPin,
  AlertTriangle
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const UrmarirePlati = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('toate');
  const [filterPeriod, setFilterPeriod] = useState('toate');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  // Date plăți OSIS
  const platiData = [
    {
      id: 'PLATA-001',
      facturaId: 'TBC001',
      client: 'Popescu Maria',
      tipClient: 'Persoană fizică',
      telefon: '+40 722 123 456',
      email: 'maria.popescu@email.com',
      adresa: 'Str. Florilor 25, Suceava',
      suma: 3784.20,
      dataScadenta: '2024-10-01',
      dataPlata: '2024-09-15',
      metodaPlata: 'Transfer bancar',
      status: 'Plătită',
      zilePlataDupa: -16,
      observatii: 'Plată primită în avans',
      istoricUrmărire: [
        { data: '2024-09-01', actiune: 'Factură emisă', utilizator: 'Sistem' },
        { data: '2024-09-15', actiune: 'Plată primită', utilizator: 'Ionel Filip' }
      ]
    },
    {
      id: 'PLATA-002',
      facturaId: 'TBC002',
      client: 'SC Constructor Alpha SRL',
      tipClient: 'Persoană juridică',
      telefon: '+40 721 987 654',
      email: 'facturi@constructoralpha.ro',
      adresa: 'Bd. Eroilor 15, Suceava',
      suma: 26751.20,
      dataScadenta: '2024-10-03',
      dataPlata: null,
      metodaPlata: 'Transfer bancar',
      status: 'În așteptare',
      zilePlataDupa: 7,
      observatii: 'Trimise 2 reminder-uri, client confirmat plata pentru săptămâna viitoare',
      istoricUrmărire: [
        { data: '2024-09-03', actiune: 'Factură emisă', utilizator: 'Sistem' },
        { data: '2024-09-18', actiune: 'Primul reminder trimis', utilizator: 'Ciprian Aostăcioaei' },
        { data: '2024-09-25', actiune: 'Al doilea reminder trimis', utilizator: 'Ciprian Aostăcioaei' },
        { data: '2024-10-02', actiune: 'Apel telefonic - client confirmă plata', utilizator: 'Ionel Filip' }
      ]
    },
    {
      id: 'PLATA-003',
      facturaId: 'TBC003',
      client: 'Georgescu Ion',
      tipClient: 'Persoană fizică',
      telefon: '+40 723 456 789',
      email: 'ion.georgescu@email.com',
      adresa: 'Str. Mihai Viteazu 8, Râșnov',
      suma: 6818.70,
      dataScadenta: '2024-10-05',
      dataPlata: null,
      metodaPlata: 'Numerar',
      status: 'În așteptare',
      zilePlataDupa: 5,
      observatii: 'Client fidel, de obicei plătește în ultimele zile',
      istoricUrmărire: [
        { data: '2024-09-05', actiune: 'Factură emisă', utilizator: 'Sistem' },
        { data: '2024-09-20', actiune: 'Reminder automat trimis', utilizator: 'Sistem' }
      ]
    },
    {
      id: 'PLATA-004',
      facturaId: 'TBC004',
      client: 'Vila Primăverii SRL',
      tipClient: 'Persoană juridică',
      telefon: '+40 724 567 890',
      email: 'contabilitate@vilaprimaverii.ro',
      adresa: 'Str. Postavaru 12, Predeal',
      suma: 8115.80,
      dataScadenta: '2024-10-07',
      dataPlata: null,
      metodaPlata: 'Transfer bancar',
      status: 'În așteptare',
      zilePlataDupa: 3,
      observatii: 'Proiect premium, client de încredere',
      istoricUrmărire: [
        { data: '2024-09-07', actiune: 'Factură emisă', utilizator: 'Sistem' }
      ]
    },
    {
      id: 'PLATA-005',
      facturaId: 'TBC005',
      client: 'Marinescu Ana',
      tipClient: 'Persoană fizică',
      telefon: '+40 722 678 901',
      email: 'ana.marinescu@email.com',
      adresa: 'Str. Dealul Mare 33, Suceava',
      suma: 3772.30,
      dataScadenta: '2024-10-10',
      dataPlata: '2024-09-12',
      metodaPlata: 'Card',
      status: 'Plătită',
      zilePlataDupa: -28,
      observatii: 'Plată imediată prin card la finalizarea montajului',
      istoricUrmărire: [
        { data: '2024-09-10', actiune: 'Factură emisă', utilizator: 'Sistem' },
        { data: '2024-09-12', actiune: 'Plată prin card', utilizator: 'Daniel Bărbosu' }
      ]
    },
    {
      id: 'PLATA-006',
      facturaId: 'TBC006',
      client: 'Hotel Mountain View SRL',
      tipClient: 'Persoană juridică',
      telefon: '+40 724 567 890',
      email: 'facturi@mountainview.ro',
      adresa: 'Str. Postavaru 15, Predeal',
      suma: 18500.00,
      dataScadenta: '2024-09-20',
      dataPlata: null,
      metodaPlata: 'Transfer bancar',
      status: 'Restantă',
      zilePlataDupa: 20,
      observatii: 'URGENT: Plată restantă, necesită acțiune imediată!',
      istoricUrmărire: [
        { data: '2024-08-20', actiune: 'Factură emisă', utilizator: 'Sistem' },
        { data: '2024-09-05', actiune: 'Primul reminder trimis', utilizator: 'Ionel Filip' },
        { data: '2024-09-12', actiune: 'Al doilea reminder trimis', utilizator: 'Ionel Filip' },
        { data: '2024-09-20', actiune: 'Apel telefonic - promisiune de plată', utilizator: 'Ciprian Aostăcioaei' },
        { data: '2024-10-01', actiune: 'Scrisoare de întârziere trimisă', utilizator: 'Ionel Filip' }
      ]
    },
    {
      id: 'PLATA-007',
      facturaId: 'TBC007',
      client: 'Asociația Proprietarilor B12',
      tipClient: 'Asociație',
      telefon: '+40 721 555 123',
      email: 'admin@ap-b12.ro',
      adresa: 'Bl. B12, Suceava',
      suma: 15280.00,
      dataScadenta: '2024-08-30',
      dataPlata: null,
      metodaPlata: 'Transfer bancar',
      status: 'Restantă',
      zilePlataDupa: 41,
      observatii: 'CRITIC: Restanță mare, proceduri juridice în curs!',
      istoricUrmărire: [
        { data: '2024-07-30', actiune: 'Factură emisă', utilizator: 'Sistem' },
        { data: '2024-08-15', actiune: 'Primul reminder trimis', utilizator: 'Ionel Filip' },
        { data: '2024-08-30', actiune: 'Apel telefonic - probleme financiare asociație', utilizator: 'Ciprian Aostăcioaei' },
        { data: '2024-09-10', actiune: 'Întâlnire cu președintele asociației', utilizator: 'Ionel Filip' },
        { data: '2024-09-25', actiune: 'Somație de plată trimisă', utilizator: 'Ionel Filip' }
      ]
    }
  ];

  // KPI-uri plăți
  const platiKPIs = {
    totalAsteptate: platiData.filter(p => p.status === 'În așteptare').length,
    sumaAsteptata: platiData.filter(p => p.status === 'În așteptare').reduce((sum, p) => sum + p.suma, 0),
    totalPlatite: platiData.filter(p => p.status === 'Plătită').length,
    sumaPlatita: platiData.filter(p => p.status === 'Plătită').reduce((sum, p) => sum + p.suma, 0),
    totalRestante: platiData.filter(p => p.status === 'Restantă').length,
    sumaRestanta: platiData.filter(p => p.status === 'Restantă').reduce((sum, p) => sum + p.suma, 0),
    rataColectare: Math.round((platiData.filter(p => p.status === 'Plătită').length / platiData.length) * 100)
  };

  // Filtrare plăți
  const filteredPayments = platiData.filter(plata => {
    const matchesSearch = plata.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         plata.facturaId.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'toate' || plata.status.toLowerCase() === filterStatus.toLowerCase();
    
    let matchesPeriod = true;
    if (filterPeriod !== 'toate') {
      const today = new Date();
      const scadentaDate = new Date(plata.dataScadenta);
      const daysDiff = Math.floor((today - scadentaDate) / (1000 * 60 * 60 * 24));
      
      switch (filterPeriod) {
        case 'scadente':
          matchesPeriod = daysDiff <= 7 && daysDiff >= 0 && plata.status !== 'Plătită';
          break;
        case 'restante':
          matchesPeriod = daysDiff > 0 && plata.status !== 'Plătită';
          break;
        case 'viitoare':
          matchesPeriod = daysDiff < 0;
          break;
      }
    }
    
    return matchesSearch && matchesStatus && matchesPeriod;
  });

  const getStatusColor = (status) => {
    switch(status) {
      case 'Plătită': return 'success';
      case 'În așteptare': return 'warning';
      case 'Restantă': return 'error';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'Plătită': return <CheckCircle className="w-4 h-4" />;
      case 'În așteptare': return <Clock className="w-4 h-4" />;
      case 'Restantă': return <AlertCircle className="w-4 h-4" />;
      default: return <CreditCard className="w-4 h-4" />;
    }
  };

  const getPriorityLevel = (zilePlataDupa, status) => {
    if (status === 'Plătită') return 'success';
    if (status === 'Restantă') return 'error';
    if (zilePlataDupa >= 0 && zilePlataDupa <= 7) return 'warning';
    return 'info';
  };

  const handleViewPayment = (plata) => {
    setSelectedPayment(plata);
    setShowPaymentModal(true);
  };

  const tableColumns = [
    {
      header: 'Factură',
      accessor: 'facturaId',
      cell: (row) => (
        <div className="flex items-center space-x-3">
          {getStatusIcon(row.status)}
          <div>
            <p className="font-semibold text-gray-900 dark:text-white">{row.facturaId}</p>
            <p className="text-sm text-gray-500">{row.id}</p>
          </div>
        </div>
      ),
    },
    {
      header: 'Client',
      accessor: 'client',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          {row.tipClient === 'Persoană juridică' ? 
            <Building className="w-4 h-4 text-gray-400" /> : 
            <User className="w-4 h-4 text-gray-400" />
          }
          <div>
            <p className="font-medium text-gray-900 dark:text-white">{row.client}</p>
            <p className="text-sm text-gray-500">{row.tipClient}</p>
          </div>
        </div>
      ),
    },
    {
      header: 'Suma',
      accessor: 'suma',
      cell: (row) => (
        <div className="text-right">
          <p className="font-bold text-gray-900 dark:text-white">
            {row.suma.toLocaleString('ro-RO', { minimumFractionDigits: 2 })} RON
          </p>
          <p className="text-xs text-gray-500">{row.metodaPlata}</p>
        </div>
      ),
    },
    {
      header: 'Scadență',
      accessor: 'dataScadenta',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          <Calendar className="w-4 h-4 text-gray-400" />
          <div>
            <p className="text-sm font-medium">
              {new Date(row.dataScadenta).toLocaleDateString('ro-RO')}
            </p>
            {row.status !== 'Plătită' && (
              <p className={`text-xs ${
                row.zilePlataDupa > 0 ? 'text-red-600' :
                row.zilePlataDupa >= -7 ? 'text-yellow-600' : 'text-gray-500'
              }`}>
                {row.zilePlataDupa > 0 ? 
                  `${row.zilePlataDupa} zile restantă` :
                  `${Math.abs(row.zilePlataDupa)} zile până la scadență`
                }
              </p>
            )}
          </div>
        </div>
      ),
    },
    {
      header: 'Status',
      accessor: 'status',
      cell: (row) => (
        <div className="flex flex-col items-center space-y-1">
          <Badge variant={getStatusColor(row.status)}>
            {row.status}
          </Badge>
          {row.status === 'Plătită' && row.dataPlata && (
            <p className="text-xs text-gray-500">
              {new Date(row.dataPlata).toLocaleDateString('ro-RO')}
            </p>
          )}
        </div>
      ),
    },
    {
      header: 'Prioritate',
      accessor: 'priority',
      cell: (row) => {
        const priority = getPriorityLevel(row.zilePlataDupa, row.status);
        const urgencyText = 
          row.status === 'Restantă' ? 'URGENT' :
          row.zilePlataDupa >= 0 && row.zilePlataDupa <= 7 ? 'Scadentă' :
          row.status === 'Plătită' ? 'OK' : 'Normal';
        
        return (
          <div className="flex items-center space-x-2">
            {row.status === 'Restantă' && <AlertTriangle className="w-4 h-4 text-red-600" />}
            <Badge variant={priority} size="sm">
              {urgencyText}
            </Badge>
          </div>
        );
      },
    },
    {
      header: 'Acțiuni',
      accessor: 'actions',
      cell: (row) => (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => handleViewPayment(row)}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          {row.status !== 'Plătită' && (
            <>
              <button
                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                title="Trimite reminder"
              >
                <Send className="w-4 h-4" />
              </button>
              <button
                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                title="Marchează ca plătit"
              >
                <CheckCircle className="w-4 h-4" />
              </button>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Urmărire Plăți OSIS
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Monitorizare automată plăți și notificări pentru facturile de pardoseli industriale
          </p>
        </div>
        
        <div className="flex gap-3">
          <button className="btn-secondary flex items-center gap-2">
            <Download className="w-4 h-4" />
            Export Restante
          </button>
          <button className="btn-primary flex items-center gap-2">
            <Plus className="w-4 h-4" />
            Înregistrare Plată
          </button>
        </div>
      </div>

      {/* KPI-uri */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Plăți în Așteptare</p>
              <p className="text-2xl font-bold text-yellow-600">{platiKPIs.totalAsteptate}</p>
              <p className="text-sm text-yellow-700">
                {platiKPIs.sumaAsteptata.toLocaleString('ro-RO')} RON
              </p>
            </div>
            <Clock className="w-8 h-8 text-yellow-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Plăți Primite</p>
              <p className="text-2xl font-bold text-green-600">{platiKPIs.totalPlatite}</p>
              <p className="text-sm text-green-700">
                {platiKPIs.sumaPlatita.toLocaleString('ro-RO')} RON
              </p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Plăți Restante</p>
              <p className="text-2xl font-bold text-red-600">{platiKPIs.totalRestante}</p>
              <p className="text-sm text-red-700">
                {platiKPIs.sumaRestanta.toLocaleString('ro-RO')} RON
              </p>
            </div>
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Rata Colectare</p>
              <p className="text-2xl font-bold text-primary-600">{platiKPIs.rataColectare}%</p>
              <p className="text-sm text-gray-600">
                {platiKPIs.totalPlatite}/{platiData.length} facturi
              </p>
            </div>
            <TrendingUp className="w-8 h-8 text-primary-600" />
          </div>
        </Card>
      </div>

      {/* Alerte Urgente */}
      {platiKPIs.totalRestante > 0 && (
        <Card>
          <div className="flex items-start gap-3 p-4 bg-red-50 dark:bg-red-900/20 rounded-lg">
            <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5" />
            <div className="flex-1">
              <h3 className="font-semibold text-red-800 dark:text-red-200">
                Alertă Plăți Restante - Acțiune Urgentă Necesară!
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                {platiData.filter(p => p.status === 'Restantă').map(plata => (
                  <div key={plata.id} className="flex items-center justify-between p-3 bg-white dark:bg-red-800/20 rounded-lg">
                    <div>
                      <p className="font-medium text-red-900 dark:text-red-100 text-sm">
                        {plata.client} - {plata.facturaId}
                      </p>
                      <p className="text-red-700 dark:text-red-300 text-xs">
                        {plata.suma.toLocaleString('ro-RO')} RON - {plata.zilePlataDupa} zile restantă
                      </p>
                    </div>
                    <button 
                      onClick={() => handleViewPayment(plata)}
                      className="btn-sm bg-red-600 hover:bg-red-700 text-white"
                    >
                      <Eye className="w-3 h-3 mr-1" />
                      Vezi
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
      )}

      {/* Filtre și Căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Căutare client sau factură..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input pl-10"
              />
            </div>
          </div>
          
          <div className="flex gap-3">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="form-input"
            >
              <option value="toate">Toate statusurile</option>
              <option value="în așteptare">În așteptare</option>
              <option value="plătită">Plătită</option>
              <option value="restantă">Restantă</option>
            </select>

            <select
              value={filterPeriod}
              onChange={(e) => setFilterPeriod(e.target.value)}
              className="form-input"
            >
              <option value="toate">Toate perioadele</option>
              <option value="scadente">Scadente (7 zile)</option>
              <option value="restante">Restante</option>
              <option value="viitoare">Viitoare</option>
            </select>
            
            <button className="btn-secondary flex items-center gap-2">
              <Filter className="w-4 h-4" />
              Mai multe filtre
            </button>
          </div>
        </div>
      </Card>

      {/* Tabel Plăți */}
      <Card title="Lista Plăților" icon={CreditCard}>
        <div className="overflow-x-auto">
          <Table 
            columns={tableColumns} 
            data={filteredPayments}
          />
        </div>
      </Card>

      {/* Modal Detalii Plată */}
      <Modal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        title={`Detalii Plată ${selectedPayment?.facturaId || ''}`}
        size="lg"
      >
        {selectedPayment && (
          <div className="space-y-6">
            {/* Header plată */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  Informații Plată
                </h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600">ID Plată:</span>
                    <span className="font-semibold">{selectedPayment.id}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Nr. Factură:</span>
                    <span className="font-semibold">{selectedPayment.facturaId}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Suma:</span>
                    <span className="font-bold text-primary-600">
                      {selectedPayment.suma.toLocaleString('ro-RO')} RON
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Scadență:</span>
                    <span>{new Date(selectedPayment.dataScadenta).toLocaleDateString('ro-RO')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Status:</span>
                    <Badge variant={getStatusColor(selectedPayment.status)}>
                      {selectedPayment.status}
                    </Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Metodă plată:</span>
                    <span>{selectedPayment.metodaPlata}</span>
                  </div>
                  {selectedPayment.dataPlata && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">Data plății:</span>
                      <span className="text-green-600 font-medium">
                        {new Date(selectedPayment.dataPlata).toLocaleDateString('ro-RO')}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  Date Client
                </h3>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center space-x-2">
                    {selectedPayment.tipClient === 'Persoană juridică' ? 
                      <Building className="w-4 h-4 text-gray-400" /> : 
                      <User className="w-4 h-4 text-gray-400" />
                    }
                    <span className="font-semibold">{selectedPayment.client}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-600">Tip:</span>
                    <span>{selectedPayment.tipClient}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Phone className="w-4 h-4 text-gray-400" />
                    <span>{selectedPayment.telefon}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Mail className="w-4 h-4 text-gray-400" />
                    <span>{selectedPayment.email}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <MapPin className="w-4 h-4 text-gray-400" />
                    <span className="text-sm">{selectedPayment.adresa}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Status și urgența */}
            {selectedPayment.status !== 'Plătită' && (
              <div className={`p-4 rounded-lg ${
                selectedPayment.status === 'Restantă' 
                  ? 'bg-red-50 dark:bg-red-900/20'
                  : selectedPayment.zilePlataDupa >= 0 && selectedPayment.zilePlataDupa <= 7
                  ? 'bg-yellow-50 dark:bg-yellow-900/20'
                  : 'bg-blue-50 dark:bg-blue-900/20'
              }`}>
                <div className="flex items-center space-x-2 mb-2">
                  {selectedPayment.status === 'Restantă' ? (
                    <AlertTriangle className="w-5 h-5 text-red-600" />
                  ) : (
                    <Clock className="w-5 h-5 text-yellow-600" />
                  )}
                  <h4 className={`font-semibold ${
                    selectedPayment.status === 'Restantă' 
                      ? 'text-red-800 dark:text-red-200'
                      : 'text-yellow-800 dark:text-yellow-200'
                  }`}>
                    {selectedPayment.status === 'Restantă' 
                      ? `Plată restantă cu ${selectedPayment.zilePlataDupa} zile`
                      : selectedPayment.zilePlataDupa >= 0
                      ? `Plată cu întârziere de ${selectedPayment.zilePlataDupa} zile`
                      : `${Math.abs(selectedPayment.zilePlataDupa)} zile până la scadență`
                    }
                  </h4>
                </div>
              </div>
            )}

            {/* Observații */}
            {selectedPayment.observatii && (
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
                  Observații
                </h4>
                <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg">
                  <p className="text-blue-800 dark:text-blue-200 text-sm">
                    {selectedPayment.observatii}
                  </p>
                </div>
              </div>
            )}

            {/* Istoric urmărire */}
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-4">
                Istoric Urmărire
              </h4>
              <div className="space-y-3">
                {selectedPayment.istoricUrmărire.map((istoric, index) => (
                  <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                    <div className="flex items-center justify-center w-8 h-8 bg-primary-100 dark:bg-primary-900 rounded-full">
                      <Calendar className="w-4 h-4 text-primary-600" />
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start">
                        <p className="font-medium text-gray-900 dark:text-white">
                          {istoric.actiune}
                        </p>
                        <span className="text-xs text-gray-500">
                          {new Date(istoric.data).toLocaleDateString('ro-RO')}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {istoric.utilizator}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Acțiuni */}
            <div className="flex justify-end gap-3 pt-4 border-t">
              {selectedPayment.status !== 'Plătită' && (
                <>
                  <button className="btn-secondary flex items-center gap-2">
                    <Send className="w-4 h-4" />
                    Trimite Reminder
                  </button>
                  <button className="btn-primary flex items-center gap-2">
                    <CheckCircle className="w-4 h-4" />
                    Marchează Plătit
                  </button>
                </>
              )}
              <button className="btn-secondary flex items-center gap-2">
                <Download className="w-4 h-4" />
                Export Detalii
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default UrmarirePlati;